import { render, staticRenderFns } from "./PaymentTariffUnknown.vue?vue&type=template&id=aa50b49e&scoped=true&"
import script from "./PaymentTariffUnknown.vue?vue&type=script&lang=js&"
export * from "./PaymentTariffUnknown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa50b49e",
  null
  
)

export default component.exports